import { Component, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserDto } from 'src/app/model/account/UserDto';
import { AppInjector } from 'src/app/service/core/app-injector.service';
import { AppTranslateService } from 'src/app/service/core/app-translate.service';
import { ToastrAlertService } from 'src/app/service/core/toastr.service';
import { UserProfileService } from 'src/app/service/userProfile.service';


@Component({
  selector: 'app-base',
  template: `NO UI TO BE FOUND HERE!`
})
export class BaseComponent {
  toastrAlertService: ToastrAlertService;
  userProfileService: UserProfileService;
  userprofile: UserDto;
  router: Router;
  appTranslateService: AppTranslateService;
  lang: string;

  constructor() {
    let injector = AppInjector.getInjector();
    this.appTranslateService = injector.get(AppTranslateService);
    this.toastrAlertService = injector.get(ToastrAlertService);
    this.userProfileService = injector.get(UserProfileService);
    this.userprofile = this.userProfileService.getProfile();
    this.router = injector.get(Router);
    this.lang = this.appTranslateService.getCurrentLang();
  }

}
